<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="PSP"
            bc3="Add"
            path="add-psp"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >

        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Switch ID</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon/> </span>
                              </div>
                              <input
                                type="text"
                                v-model="switchId"
                                class="form-control"
                                :class="
                                  errorBag.has('switchId') ? 'is-invalid' : ''
                                "
                                name="switchId"
                                placeholder="Switch ID"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('switchId')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("switchId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Switch Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="rate-icon"
                                  class="form-control"
                                  v-model="name"
                                  name="name"
                                  placeholder="Name"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.back()"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { TargetIcon, Edit3Icon, CommandIcon } from "vue-feather-icons";
export default {
  components: {
    TargetIcon,
    Edit3Icon,
    CommandIcon
  },
  mounted() {},
  data() {
    return {
      switchId: '',
      imeiNumber: '',
      serialNumber: '',
      posDeviceModel:'',
      name: '',
      loading: false,
      size: "10px"
    };
  },
  methods: {
    onFileChanged(event) {
      this.logo = event.target.files[0];
    },
    sendCall() {
      return
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            name: this.name,
            posDeviceId: this.switchId,
            imeiNumber: this.imeiNumber,
            serialNumber: this.serialNumber,
            posDeviceModel: this.posDeviceModel
          }
          this.makeRequest("post", "v1/create-pos-device", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  this.$router.back()
                }
              }
              this.loading = false;
            }
          );
        }
      });
    }
  }
};
</script>

